define('home/views/HomepageFeedEmptyView',[
    'underscore',
    'backbone-marionette',

    'home/mixins/withSubviews',
    'home/models/Session',
    'home/views/ChannelCardCollectionView',
    'home/templates/homepageFeedEmpty',
    'home/templates/homepageNoChannelsFeedEmpty',
    'home/templates/spinner',
], function (
    _,
    Marionette,

    withSubviews,
    Session,
    ChannelCardCollectionView,
    homepageFeedEmptyTemplate,
    homepageNoChannelsFeedEmptyTemplate,
    spinnerTemplate
) {
    'use strict';

    /**
     * An empty state view for homepage feeds that shows a message about the purpose
     * of the current feed and a feed of the top activities from the spotlight channel.
     *
     * Expects to be backed by a feed model and a collection.
     * Expects feed specific message assigned to this.feedMessage
     */
    var HomepageFeedEmptyView = Marionette.ItemView.extend({
        initialize: function (options) {
            this.session = Session.get();
            this.maxItemsText = options.maxItemsText;
            this.onboardingWithoutChannels = options.onboardingWithoutChannels;
            this.model.ensureFetched().then(this.render);
        },

        getTemplate: function () {
            var emptyTemplate = this.onboardingWithoutChannels ?
                homepageNoChannelsFeedEmptyTemplate :
                homepageFeedEmptyTemplate;
            return this.model.get('fetched') ? emptyTemplate : spinnerTemplate;
        },

        templateHelpers: function () {
            return _.defaults(this.noChannelEmptyViewTexts, {
                numItemsShown: this.maxItemsText,
                feedMessage: this.feedMessage,
                isLoggedIn: this.session.isLoggedIn(),
            });
        },

        regions: {
            feedRegion: '[data-role=items]',
        },

        onRender: function () {
            this.activateRegion(this.feedRegion, this.createFeedView);
        },

        createFeedView: function () {
            return new ChannelCardCollectionView({
                model: this.model,
                collection: this.collection,
                emptyView: null,
            });
        },
    });

    withSubviews.call(HomepageFeedEmptyView.prototype);

    return HomepageFeedEmptyView;
});

